export default [
  { title: "Create a brand", icon: "", link: "/docs/create-brand" },
  { title: "Apply a brand to an envelope", icon: "", link: "/docs/apply-brand" },
  { title: "Apply a brand  and a template to an envelope", icon: "", link: "/docs/apply-brand-template" },
];
